module.exports = require('./helpers/bundle-url').getBundleURL('dj12v') + "tallyho.56ec6262.svg";